
class ArtieFAQSearch {
  constructor() {
    this.searchInputs = document.querySelectorAll('[data-faq-search-input]');
    this.faqItems = document.querySelectorAll('[data-faq-item]');
    this.faqCategories = document.querySelectorAll('[data-faq-category]');
    this.noResults = document.querySelector('[data-faq-no-results]');
    this.resultCounts = document.querySelectorAll('[data-faq-search-results]');
    this.countTexts = document.querySelectorAll('[data-faq-search-count]');
    
    this.init();
  }

  init() {
    this.searchInputs.forEach(input => {
      input.addEventListener('input', (e) => this.handleSearch(e.target.value));
      
      const clearBtn = input.parentElement.querySelector('[data-faq-search-clear]');
      if (clearBtn) {
        clearBtn.addEventListener('click', () => {
          input.value = '';
          this.handleSearch('');
          input.focus();
        });
      }
    });
  }

  handleSearch(query) {
    const searchTerm = query.toLowerCase().trim();
    let visibleCount = 0;

    // Toggle clear button
    this.searchInputs.forEach(input => {
      const clearBtn = input.parentElement.querySelector('[data-faq-search-clear]');
      if (clearBtn) {
        if (searchTerm.length > 0) {
          clearBtn.classList.remove('hidden');
        } else {
          clearBtn.classList.add('hidden');
        }
      }
    });

    if (searchTerm === '') {
      this.resetFAQs();
      return;
    }

    this.faqItems.forEach(item => {
      const text = item.textContent.toLowerCase();
      if (text.includes(searchTerm)) {
        item.classList.remove('hidden');
        visibleCount++;
      } else {
        item.classList.add('hidden');
      }
    });

    this.updateCategories();
    this.updateResultsCount(visibleCount, true);
    
    if (this.noResults) {
      if (visibleCount === 0) {
        this.noResults.classList.remove('hidden');
      } else {
        this.noResults.classList.add('hidden');
      }
    }
  }

  resetFAQs() {
    this.faqItems.forEach(item => item.classList.remove('hidden'));
    this.faqCategories.forEach(cat => cat.classList.remove('hidden'));
    if (this.noResults) this.noResults.classList.add('hidden');
    this.updateResultsCount(0, false);
  }

  updateCategories() {
    this.faqCategories.forEach(category => {
      let nextElement = category.nextElementSibling;
      let hasVisibleItem = false;

      while (nextElement && !nextElement.hasAttribute('data-faq-category')) {
        if (nextElement.hasAttribute('data-faq-item') && !nextElement.classList.contains('hidden')) {
          hasVisibleItem = true;
          break;
        }
        nextElement = nextElement.nextElementSibling;
      }

      if (hasVisibleItem) {
        category.classList.remove('hidden');
      } else {
        category.classList.add('hidden');
      }
    });
  }

  updateResultsCount(count, show) {
    this.resultCounts.forEach(el => {
      if (show && count >= 0) {
        el.classList.remove('hidden');
      } else {
        el.classList.add('hidden');
      }
    });

    this.countTexts.forEach(el => {
      el.textContent = count;
    });
  }
}

document.addEventListener('DOMContentLoaded', () => {
  new ArtieFAQSearch();
});

// Handle Shopify Theme Editor events
document.addEventListener('shopify:section:load', () => {
  new ArtieFAQSearch();
});
